module.exports = __webpack_public_path__ + "img/corsi_online_domande_smartform.ccd465d2.png";